import api from '../api';
import { POS_ENDPOINT } from './pos';

export const ReceivingMode = {
  INVALID: 0,
  DIRECT: 1,
  CART: 2,
  CARD: 3,
  RECHARGE: 4,
};

export enum PaymentChannel {
  Online = -1,
  INVALID = -2,
  Cash = 1,
  Tenpay = 1 << 1,
  Alipay = 1 << 2,
  Groupon_MT = 1 << 3,
  Groupon_DY = 1 << 4,
}

export const isGrouponPaymentChannel = (chnnel: PaymentChannel) => {
  return chnnel === PaymentChannel.Groupon_MT || chnnel === PaymentChannel.Groupon_DY;
};

/**
 * pos codepay 支付过程消息
 */
export type PosCodePayProceedingInfo = {
  msg: string;
  tradeStatus:
    | 'WAIT_BUYER_PAY'
    | 'TRADE_CLOSED'
    | 'TRADE_SUCCESS'
    | 'TRADE_FINISHED'
    // 腾讯支付
    | 'USERPAYING';
  orderSn: string;
  paymentChannel: PaymentChannel;
};

export const codePayTradeCancel = async (data: {
  orderSn: string;
  paymentChannel: PaymentChannel;
}) => {
  return await api.post({
    url: `${POS_ENDPOINT}/trade/cancel`,
    data,
  });
};
